<template>
	<div class="msgpagemain" @click="closetool">
		<div class="header">
			<h3 class="msstitle">消息中心</h3>
			<span class="close" @click="close">
				<i class="el-icon-close"></i>
			</span>
		</div>
		<div class="messagehader">
			<div>你有{{num}}條未讀消息</div>
			<div @click="clearall" class="clearmessage">清除</div>
		</div>
		<div class="messbox">
			<div v-if="dataList">
				<template v-for="(item,ordernum) in dataList">
					<ul class="messgaelist">
						<li>
							<div class="ordernum">{{ordernum}}</div>
							<ul class="msggroup">
								<li @click.stop="Details(msg.order_id,msg.id)" v-for="msg in item">
									<div class="libox" :class="{active:opentooleactive==msg.id}">
										<div class="userbox">
											<div class="userface" style="background-size: 100% 100%;" :style="{'background-image':'url('+apiurl+msg.from_thumb+')'}"></div>
											<span v-if="msg.to_view == 0 && msg.from_id != user_id" class="newmes">new</span>
										</div>

										<div class="msbox">
											<div class="msheader">
												<div class="username">{{msg.from_username}}</div>
												<div class="addtime">{{msg.addtime}}</div>
											</div>
											<div class="mscontentbox">
												<div class="mscontent">
													<div><span v-if="msg.replay == 1">回復：</span>{{msg.content}}</div>
													<div>
														<div v-if="(msg.from_id == user_id) && (msg.replay == 0)" class="frommsg">(你發送給{{msg.to_username}})</div>
														<div v-else-if="(msg.from_id == user_id) && (msg.replay == 1)" class="frommsg">(你回復給{{msg.to_username}})</div>
													</div>
												</div>
												<div class="msright">
													<i @click.stop="opentool(msg.id)" class="el-icon-caret-bottom"></i>
													<ul v-show="opentooleactive==msg.id" class="messtoolbox">
														<li @click.stop="clear(msg.id)">清除</li>
														<li>
															<div>
																<div v-if="msg.to_locked == 0 && user_id != msg.from_id" @click.stop="lock(msg.id)">鎖定</div>
																<div v-else-if="msg.from_locked == 0 && user_id == msg.from_id" @click.stop="lock(msg.id)">鎖定</div>
															</div>

															<div>
																<div v-if="msg.to_locked == 1 && user_id != msg.from_id" @click.stop="unlock(msg.id)">解锁</div>
																<div v-else-if="msg.from_locked == 1 && user_id == msg.from_id" @click.stop="unlock(msg.id)">解锁</div>
															</div>
														</li>



														<li v-if="msg.from_id != user_id" @click.stop="openreplaymessage(msg)">回復</li>
													</ul>

												</div>
											</div>

										</div>
									</div>
								</li>

							</ul>
						</li>
					</ul>
				</template>
			</div>
			<div v-else>
				<el-card shadow="never">
					<p class="text-align-center">
						暫無信息！
					</p>
				</el-card>
			</div>
		</div>
		<el-dialog @closed="closereplaymessage" title="回复消息" :visible.sync="replaymessage" width="95%" :append-to-body="true">
			<component @parentmsg="parentmsg" @closedialog="closedialog" :replay="replay" :is="replaymessage_component"></component>
		</el-dialog>
	</div>
</template>

<script>
	import replaymessage from "./ReplayMessage.vue";
	export default {
		props: ['refresh'],
		components: {
			replaymessage
		},
		name: "MessageListCom",
		data() {
			return {
				dataList: {},
				opentooleactive: 0,
				replaymessage: false,
				replaymessage_component: '',
				replay: {},
				num: 0,
				user_id: 0
			}
		},
		watch: {
			refresh() {
				this.getmessage();
			}
			
		},
		methods: {
			parentmsg() {
				this.getmessage();
			},
			closedialog() {
				this.replaymessage = false;
				this.replaymessage_component = '';
				this.opentooleactive = 0;
			},
			closereplaymessage() {
				this.replaymessage = false;
				this.replaymessage_component = '';
				this.opentooleactive = 0;
			},
			openreplaymessage(item) {
				this.replay = item;
				this.replaymessage = true;
				this.replaymessage_component = replaymessage;
				this.opentooleactive = 0;
			},
			clearall() {
				let user_id = sessionStorage.getItem('user_id');
				this.post('/api/message/clearall', {
					user_id: user_id
				}).then((res) => {
					console.log(res);
					if (res == 'success') {
						this.$emit('changemessagenum', '1');
						this.getmessage();
					}
				})
			},

			lock(message_id) {
				this.post('/api/message/locked', {
					message_id: message_id,
					user_id: this.user_id
				}).then((res) => {
					if (res == 'success') {
						this.$emit('changemessagenum', '1');
						this.getmessage();
						this.opentooleactive = 0;
					}
				})
			},
			unlock(message_id) {
				this.post('/api/message/unlocked', {
					message_id: message_id,
					user_id: this.user_id
				}).then((res) => {

					if (res == 'success') {
						this.$emit('changemessagenum', '1');
						this.getmessage();
						this.opentooleactive = 0;
					}
				})
			},
			clear(message_id) {
				this.post('/api/message/clear', {
					message_id: message_id,
					user_id: this.user_id
				}).then((res) => {

					if (res == 'success') {
						this.$emit('changemessagenum', '1');
						this.getmessage();
					} else if (res == 'locked') {
						this.$notify({
							title: '通知',
							type: 'error',
							message: '该条消息已被锁定！',
						});
					}
				})
			},
			closetool() {
				this.opentooleactive = 0;
			},
			opentool(message_id) {
				this.opentooleactive = message_id;
			},
			Details(order_id, message_id) {

				this.$router.push({
					name: '/OrderDetails',
					path: '/OrderDetails',
					query: {
						id: order_id
					}
				})

				this.viewed(message_id);

			},
			viewed(message_id) {

				this.post('/api/message/viewed', {
					message_id: message_id,
					user_id: this.user_id
				}).then((res) => {

					if (res == 'success') {
						this.$emit('changemessagenum', '1');
						this.close();
					}

				})
			},
			getmessage() {
				let user_id = parseInt(sessionStorage.getItem('user_id'));
				this.post('/api/message/getmessage', {
					to_id: user_id
				}).then((res) => {
					this.getmessagenum();
					this.dataList = res;
				})
			},
			getmessagenum() {
				let user_id = parseInt(sessionStorage.getItem('user_id'));
				this.post('/api/message/getmessagenum', {
					to_id: user_id
				}).then((res) => {
					this.$emit('msgnum', '1');
					if (res) {
						this.num = res;
					} else {
						this.num = 0;
					}
				})
			},
			close() {
				this.$emit('closemsgcenter', false);
			},


		},
		created() {
			this.user_id = parseInt(sessionStorage.getItem('user_id'));
			
			this.getmessage();
		}
	}
</script>

<style scoped>
	.addtime{ font-size: 12px; color: #999;}
	.username {
		font-weight: bold;
	}

	
	.newmes {
		color: #fff;
		background: #f60;
		padding: 2px 5px;
		margin-left: 4px;
	}

	.frommsg {
		font-size: 12px;
		color: #a1a1a1;
	}

	.messtoolbox {
		position: absolute;
		background: #fff;
		left: -50px;
		top: 20px;
		border: 1px solid #e2e2e2;
		z-index: 1;
	}

	.messtoolbox>li {
		height: 25px;
		line-height: 25px;
		width: 80px;
		text-align: center;
	}

	.ordernum {
		color: #3b3bff;
		background: #f2f2f2;
		margin-bottom: 10px;
		padding: 5px;
		padding-left: 15px;
	}

	.header {
		padding: 15px;
		display: flex;
		justify-content: space-between;
	}

	.msstitle {
		text-align: center;
	}

	.messbox {
		height: calc(100vh - 140px);
		overflow-x: hidden;
		padding: 0 15px;
	}

	.mscontentbox {
		display: flex;
		justify-content: space-between;
		padding: 10px 0;
	}

	.mscontent {
		text-align: justify;
	}

	.msbox {
		flex: 1 auto;
	}

	.msright {
		flex: 0 30px;
		position: relative;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
	}

	.msright i {
		font-size: 23px;
		color: #666666;
		position: absolute;
		top: -4px;
		left: 10px;
	}

	.msheader {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.messgaelist .libox {
		display: flex;
	}

	.messgaelist>li {}

	.msggroup>li:last-child {
		margin-bottom: 10px;
	}

	.libox {
		padding: 10px;
	}

	.libox.active {
		background-color: #F0F5FA
	}

	.userbox {
		flex: 0 0 45px;
	}

	.userface {
		width: 45px;
		height: 45px;
		border-radius: 50%;
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.clearmessage {
		padding: 2px 15px;
		background: #3399ff;
		border-radius: 4px;
		color: #fff;
		cursor: pointer;
	}

	.messagehader {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 15px 15px 15px;
	}

	.header {
		position: relative;
	}

	.text-red {
		color: red;
	}
</style>
